import { Component, OnDestroy, OnInit, inject, input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PhoneUiContext } from '../../../../shared/phone-buttons/contexts/phone-ui.context';
import { Subscription } from 'rxjs';
import { ZiroIcons } from '../../../../shared/models/ziro-icons.enum';
import { HelpdeskOptionsContext } from '../../../shared/contexts/helpdesk-options.context';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ziro-public-phone-operations-menu',
  templateUrl: './public-phone-operations-menu.component.html',
  styleUrls: ['./public-phone-operations-menu.component.scss'],
  standalone: false,
})
export class PublicPhoneOperationsMenuComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private phoneUiContext = inject(PhoneUiContext);
  private helpdeskOptionsContext = inject(HelpdeskOptionsContext);
  private router = inject(Router);
  _translateService = inject(TranslateService);

  readonly phoneId = input<string>();
  readonly isCopyPhoneButtonEnabled = input(true);
  readonly isUnsavedCopy = input(true);

  ziroIcons = ZiroIcons;
  isVoicemailPresentOnLineOne = false;
  isChangeSiteEnabled = false;
  phoneName = '';

  private _subs = new Subscription();

  ngOnInit(): void {
    this.phoneName = this.route.snapshot.params.phoneName;

    const helpdeskOptionsSub = this.helpdeskOptionsContext.state$.subscribe((helpdeskOptions) => {
      this.isChangeSiteEnabled =
        this.helpdeskOptionsContext.isCiscoHelpdeskOptions(helpdeskOptions) && helpdeskOptions.changeSiteEnabled;
    });
    this._subs.add(helpdeskOptionsSub);
    const phoneUiSub = this.phoneUiContext.phoneState$.subscribe((phone) => {
      this.phoneName = phone.name;
      const voicemailPresentSub = this.phoneUiContext.isVoicemailPresentOnLineOneState$.subscribe(
        (isVoicemailPresent) => {
          this.isVoicemailPresentOnLineOne = isVoicemailPresent;
        },
      );
      this._subs.add(voicemailPresentSub);
    });
    this._subs.add(phoneUiSub);
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

  goToCopyPublicPhone(): void {
    if (this.isCopyPhoneButtonEnabled()) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([`/public-phone/${this.phoneName}/copy`]);
      });
    }
  }
}
